module.exports = __webpack_public_path__ + "994f3ec5f945b7409d4cf52371ba4375.png";